import React, { useContext, useEffect, useState } from 'react';

import {
 GramUnitsPerMl,
 IEUnitsPerMl,
 MolUnitsPerMl,
 UnitType,
} from '../../../../types';

import CalculatorComponent from '../../../../components/CalculatorComponent';

import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { InfusionAddedDrugContext } from '../../../../contexts/InfusionProvider/InfusionAddedDrugProvider';
import { CalculatorContext } from '../../../../contexts/CalculatorProvider';

import { getUnitTypeByString } from '../../../../utils';

function InfusionAddedDrugThirdScreen(): React.ReactElement {
 const {
  setBackButtonText,
  setNextButtonText,
  setBackButtonAction,
  setNextButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { setQuestion, setUnitTypes, setHasCheckbox, setShowInfo } =
  useContext(CalculatorContext);

 const {
  thirdScreenRedirect,
  fifthScreenRedirect,
  onValueChange,
  onSelectChange,
  getSelectInitialState,
  getValueInitialState,
  selectedUnit,
 } = useContext(InfusionAddedDrugContext);

 const gramOptions = [
  UnitType.MicrogramPerMl,
  UnitType.MiligramPerMl,
  UnitType.GramPerMl,
 ];

 const molOptions = [
  UnitType.MicromolPerMl,
  UnitType.MilimolPerMl,
  UnitType.MolPerMl,
 ];

 const [localUnitTypes, setLocalUnitTypes] = useState(GramUnitsPerMl);

 const setNavigationProps = () => {
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(thirdScreenRedirect);
  };
  const setNextButtonProps = () => {
   setNextButtonText('Neste');
   setNextButtonAction(fifthScreenRedirect);
  };
  setBackButtonProps();
  setNextButtonProps();
 };
 const setCalculatorProps = () => {
  setQuestion('Hvilken styrke har legemiddelet pr ml?');
  setUnitTypes(localUnitTypes);
  setHasCheckbox(false);
  setShowInfo(false);
 };

 useEffect(() => {
  setNavigationProps();
  setCalculatorProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 useEffect(() => {
  const selectedUnitPerMl = `${selectedUnit}/${UnitType.Ml}`;
  if (gramOptions.includes(getUnitTypeByString(selectedUnitPerMl))) {
   setLocalUnitTypes(
    GramUnitsPerMl.filter(
     unit =>
      ![UnitType.Kilogram, UnitType.KilogramPerMl].includes(unit.description),
    ),
   );
  } else if (molOptions.includes(getUnitTypeByString(selectedUnitPerMl))) {
   setLocalUnitTypes(MolUnitsPerMl);
  } else {
   setLocalUnitTypes(IEUnitsPerMl);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 useEffect(() => {
  setUnitTypes(localUnitTypes);
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [localUnitTypes]);

 return (
  <CalculatorComponent
   onValueChange={(value: string) => onValueChange(value)}
   onSelectChange={onSelectChange}
   valueInitialState={getValueInitialState()}
   selectInitialState={getSelectInitialState()}
  />
 );
}

export default InfusionAddedDrugThirdScreen;
